import React, { Component, Fragment } from 'react';
import { FormGroup, Col, Label } from 'reactstrap';
import Select from 'react-select';
import { pregnancyType, ph, cp, previousPregnancyHeader, currentPregnancyHeader, documentsType } from '../configData';
import { getPregnancyRecordByDocument } from '../../services';
import PreviousPregnancyTable from './PreviousPregnancytable';
import CurrentPregnancyTable from './CurrentPregnancyTable';
import PrePregnancyTable from './PrePregnancyTable';

class SharePregnancyRecord extends Component {

  state = {
    pregnancy: null,
    documentType: null,
    documentsOption: []
  }

  handlePregnancy = (selectedOption) => {
    let pregnancy, tableHeader, documentsOption;
    if(selectedOption['value'] == 1) {
      pregnancy = selectedOption['value']
      tableHeader = previousPregnancyHeader;
      documentsOption = ph
  
    } else if(selectedOption['value'] == 2) {
      pregnancy = selectedOption['value']
      tableHeader = currentPregnancyHeader;
      documentsOption = cp;
    } else if(selectedOption['value'] == 3) {
      pregnancy = selectedOption['value']
      tableHeader = previousPregnancyHeader;
      documentsOption = ph
    }

    this.setState(prevState => ({
      pregnancy: pregnancy,
      tableHeader: tableHeader,
      documentsOption: documentsOption,
      documentType: null
    }))
  }

  handleDocument = async (selectedDocument) => {
    const { pregnancy } = this.state;

    let data = {
      documentType: selectedDocument['value'],
      pregnancyType: pregnancy 
    }

    const response = await getPregnancyRecordByDocument(data);

    this.setState(prevState => ({
      documentType: selectedDocument['value'],
      records: response.data.records
    }))
  }

  renderTable = () => {
    const { pregnancy, records, documentType } = this.state;

    if(pregnancy == 1) {
      return <PreviousPregnancyTable records={records}/>
    } else if(pregnancy == 2) {
      return <CurrentPregnancyTable documentTypes={documentsType[documentType]} records={records}/>
    } else if(pregnancy == 3) {
      return <PrePregnancyTable records={records}/>
    }
  }

  render () {

    const { documentsOption, pregnancy, tableHeader, records, documentType } = this.state;

    return (
      <Fragment>
        <Col md="4">
          <FormGroup>
            <Label>Select Pregnancy type</Label>
            <Select 
              options={pregnancyType}
              onChange={this.handlePregnancy}
            />
          </FormGroup>
        </Col>
        {documentsOption.length > 0 && 
          <Col md="4" key={pregnancy}>
            <FormGroup>
              <Label>Select document type</Label>
              <Select 
                options={documentsOption}
                onChange={this.handleDocument}
              />
            </FormGroup>
          </Col>
        }
        {documentType !== null && 
          <Col md="12">
            {this.renderTable()}
          </Col>
        }
      </Fragment>
    )
  }
}

export default SharePregnancyRecord;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareMyRecord/SharePregnancyRecord.js